module.exports = __webpack_public_path__ + "img/MRDB.c28e493e.jpeg";